<template>
  <div class="alibaba-cates">

      <div class="cates-items">

        <div  class="cates-item" v-for="(item,index) in cateListOne" :class="{active:(item.id==(selCateIds[0]?selCateIds[0]:0))}" @click="getCategory(item.id,1)">
          {{ item.name }}
        </div>
      </div>
      <div class="cates-items">
        <div class="cates-item" v-for="(item,index) in cateListTow" :class="{active:(item.id==(selCateIds[1]?selCateIds[1]:null))}" @click="getCategory(item.id,2)">
          {{ item.name }}
        </div>
      </div>
      <div class="cates-items">
        <div class="cates-item" v-for="(item,index) in cateListThree" :class="{active:(item.id==(selCateIds[2]?selCateIds[2]:null))}" @click="getCategory(item.id,3)">
          {{ item.name }}
        </div>
      </div>

  </div>
</template>
<script>
import alibabaProductApi from "../api";

export default {
  props: {
    value: {
      type: Array,
      default: []
    },
  },
  model: {
    prop: 'value',        // 指定 v-model 要绑定的参数叫什么名字，来自于 props 中定义的参数
    event: 'change',    // 指定要触发的事件名字，将被用于 $emit
  },
  computed: {
    selCateIds: {
      // 这里的计算属性使用了 getter、setter，可以简化代码
      // 可参见链接 https://cn.vuejs.org/v2/guide/computed.html#%E8%AE%A1%E7%AE%97%E5%B1%9E%E6%80%A7%E7%9A%84-setter
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val);    // 触发

      }
    }
  },
  data() {
    return {
      cateListOne: [],
      cateListTow: [],
      cateListThree: [],
    }
  },
  created() {
    this.getCategory(0, 0);
  },
  methods: {
    getCategory(categoryId = 0, level = 0) {

      switch (level) {
        case 0:
          this.selCateIds.length = 0;
          this.selCateIds.push(categoryId);
          break;
        case 1:
          this.selCateIds.length = 0;
          this.selCateIds.push(categoryId);
          this.cateListTow = [];
          this.cateListThree = [];
          break;
        case 2:
          this.cateListThree = [];
          this.selCateIds.length = 1;

          this.selCateIds.push(categoryId);
          break;
        case 3:
          this.selCateIds.length = 2;
          this.selCateIds.push(categoryId);
      }

      alibabaProductApi.getCategory(categoryId).then(res => {
        if (res.status == 200 && res.data) {
          if (res.data.childCategorys && res.data.childCategorys.length > 0) {
            switch (level) {
              case 0:

                this.cateListOne.push({
                  name: "全部",
                  id: 0
                });
                this.cateListOne.push(...res.data.childCategorys);
                break;
              case 1:
                if (categoryId != 0) {
                  this.cateListTow = res.data.childCategorys;
                }
                break;
              case 2:
                this.cateListThree = res.data.childCategorys;
                break;
            }

          }

        }
      })
    },
  }

}
</script>
<style scoped>
.alibaba-cates {
  padding-left: 80px;
  position: relative;
}
.alibaba-cates::before{
  position: absolute;
  color: #999999;
  content: "商品分类:";
  font-size: 14px;
  left: 0;
  top: 0;
}

.cates-items {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;

}

.cates-item {
  font-size: 12px;
  display: inline-block;
  flex: 0 0 auto;
  padding: 0 5px;
  line-height: 24px;
  cursor: pointer;
}
.cates-item.active{
  background-color: #409eff;
  color: #FFFFFF;
  border-radius: 2px;


}
</style>



// WEBPACK FOOTER //
// src/views/alibaba/product/components/alibabaCates.vue